<template>
	<div class="parent">
		<b class="largetext" v-bind:id="timeTableID+'header'">{{employeeName}}: WEEK {{searchDate}} TOTAL : 0.00</b>
		<table>
            <thead>
				<th width="50px">Hour</th>
				<th>Mon, {{getDate(1)}}</th>
				<th>Tue, {{getDate(2)}}</th>
				<th>Wed, {{getDate(3)}}</th>
				<th>Thu, {{getDate(4)}}</th>
				<th>Fri, {{getDate(5)}}</th>
				<th>Sat, {{getDate(6)}}</th>
				<th>Sun, {{getDate(7)}}</th>
			</thead>
			<tbody>
				<tr id="row_header">
					<td style="text-align:right; padding-right:2px;">
						0
					</td>

					<template v-for="r in 7">
						<td rowspan="24">

							<div class="blockcontainer" v-bind:id="timeTableID+'container-'+r">

							</div>
						</td>
					</template>
				</tr>
				<tr v-for="hour in 23">
					<td style="text-align:right; padding-right:2px;">
						{{hour}}
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<th>Total</th>
					<th v-for="h in 7" v-bind:id="timeTableID+'hours-'+h">{{totalHours[h-1]}}</th>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		timeTableID: Number,
		employeeID: Number,
		employeeName: String,
		searchDate: String,
		showEmpty: Boolean,
    },
	data() {
		return {
			column_names: [],
			column_data:[],
			heightValue:Array(2),
			topValue:Array(2),
			totalHours:[0.0,0.0,0.0,0.0,0.0,0.0,0.0],
		}
	},
	async created () {
		this.search();
	},
	methods: {
		getDate(day){
			var millis = 86400000;
			var date = new Date(this.searchDate);
			var dayNum = date.getDay();
			var dayOne = date.getTime() - (millis*dayNum)
			var endDate = new Date();
			endDate.setTime(dayOne+(millis*day));
			return(endDate.getFullYear()+"-"+(endDate.getMonth()+1)+"-"+endDate.getDate());
		},
		search (){
			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.id,
						showEmpty:this.showEmpty,
						data:[
	                        this.employeeID,
							this.searchDate
	                    ]
					}
                }
            ).then((res) => {
	            this.column_names = res.data.data.column_names;
				this.column_data = res.data.data.column_data;
	        }).finally((res) => {
				this.manageData();
			});
		},
		clearResults(){

		},
		manageData(){
			for(let i = 0;i<7;i++){
				this.heightValue[i]=[];
				this.topValue[i]=[];
			}
			var previousNum = -1;
			var iterator = 0;
			for(let i = 0; i<this.column_data.length;i++){
				var day = this.column_data[i][3]-1;
				if(isNaN(day)){
					continue;
				}

				if(previousNum==day) {
					iterator++;
				}else{
					iterator=0;
				}

				this.topValue[day][iterator]=[Math.floor((this.column_data[i][4]/100)*480)];
				this.heightValue[day][iterator]=[Math.ceil((this.column_data[i][5]/100)*480)];
				//alert(this.totalHours)
				this.totalHours[day]+=(parseFloat(this.column_data[i][5])*.24);


				previousNum=day;
			}
			this.setData();
		},
		setData(){
			var iterator = 0;
			for(let i = 0;i<7;i++){
				var parent = document.getElementById(this.timeTableID+'container-'+(i+1));
				while (parent.firstChild) {
					parent.removeChild(parent.lastChild);
				}

				for(let j = 0;j<this.heightValue[i].length;j++){
					var newChild = document.createElement("div");

					var color = this.column_data[iterator][12];
					var borderColor = this.column_data[iterator][13];
					var textColor = this.column_data[iterator][14];


					var textStyle = ' \
						font-size:12px; \
						margin-bottom:-5px; \
						margin-left:2px; \
						margin-top:0px; \
						font-color:#'+textColor+'; \
					';

					var style = ' \
						height:'+this.heightValue[i][j]+'px; \
						top:'+this.topValue[i][j]+'px; \
						position:absolute; \
						margin:auto; \
						right:5px; \
						left:5px; \
						background-color: #'+color+'; \
						border: 1px solid #'+borderColor+'; \
						border-top:3px solid #'+borderColor+'; \
						border-radius: 5px 5px 5px 5px; \
					';

					newChild.innerHTML = " \
					<p style='"+textStyle+"'>"+
						this.column_data[iterator][6]+", "+
						this.column_data[iterator][7].substr(0,20)+", "+
						this.column_data[iterator][8].substr(0,15)+", "+
						((parseFloat(this.column_data[iterator][4])*0.24).toFixed(2))+" - "+
						(((parseFloat(this.column_data[iterator][4])+parseFloat(this.column_data[iterator][5]))*0.24).toFixed(2))+", "+
						this.column_data[iterator][15]+"</p> \
					";

					var press = this.press;

					newChild.setAttribute('style', style);
					newChild.setAttribute('id', this.timeTableID+"timedata"+iterator);
					newChild.setAttribute('class', "time");
					newChild.setAttribute('title', this.column_data[iterator][16]+", "+this.column_data[iterator][10]);
					newChild.onclick = function(){press(i,j)};
					parent.appendChild(newChild);

					iterator++;
				}
			}

			var total = 0.0;
			for(let i = 0;i<7;i++){
				if(isNaN(this.totalHours[i])){
					document.getElementById(this.timeTableID+'hours-'+(i+1)).innerHTML="TBD";
				}else{
					document.getElementById(this.timeTableID+'hours-'+(i+1)).innerHTML=this.totalHours[i].toFixed(2);
					total+=this.totalHours[i];
				}
			}
			document.getElementById(this.timeTableID+'header').innerHTML=this.employeeName+": WEEK "+this.searchDate+" TOTAL : "+total.toFixed(2);
		},
		press(x,y){
			var iterator = 0;
			for(let i = 0;i<7;i++){
				for(let j = 0;j<this.heightValue[i].length;j++){
					if(i==x && j==y){
						router.push('/0301?q=11-'+this.column_data[iterator][6]);
						return;
					}
					iterator++;
				}
			}
		}
	},
	watch:{
		searchDate: function(newValue, oldValue) {
			this.search();
		},
		showEmpty: function(){
			this.search();
		}
	},
}
</script>

<style scoped>
table{
	table-layout: fixed ;
}

table,td {
	background-color: #ffffff;
	empty-cells: show;
}

thead{
	background: #d0d0d0;
	position:static;
	top:0px;
}

td{
	padding:0px;
}

td:nth-child(1){
	height:20px;
	font-size: 12px;
}

.blockcontainer{
	position:relative;
	height:480px;
	margin:0px;
	padding:0px;

	background-size: 10px 40px;
	background-image:
	linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
}

.time{
	opacity:.5;
}

.largetext{
	font-size:32px;
	margin-left:0px;
}

.parent{
	display:flex;
	max-width:100%;
	margin:auto;
	margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/timetable.vue